import React, { Dispatch, useCallback, useState } from 'react';
import { GearResponse, ProfileGear } from 'types';
import { GearCard } from 'components/GearCard';
import { getGearLike, getGearList } from 'api';

import styles from './ProductPage.module.scss';
import { Button } from '../../components/Button';
import { goToComment, handleFavorite, handleShare } from '../../utils/services';
import { SnackbarProps } from '../../components/Snackbar';

export type PageLikeGearsProps = {
  title?: string;
  likeGearSlug?: string;
  gears: GearResponse;
  isFullyAuth: boolean;
  redirectToAuth: () => any;
  setSnackbarMessage: Dispatch<SnackbarProps | null>;
  isRegularRequest?: boolean;
};

export const PageLikeGears = ({ title='More Gear to Discover', gears, likeGearSlug, isFullyAuth, redirectToAuth, setSnackbarMessage, isRegularRequest }: PageLikeGearsProps) => {
  const [hits, setHits] = useState(gears.hits);
  const [total, setTotal] = useState(gears.total);
  const [limit, setLimit] = useState(gears.limit || 12);
  const [pageLoaded, setPageLoaded] = useState(1);

  const allPagesLoaded = pageLoaded * limit >= total;

  const loadMore = async () => {
    const response =  isRegularRequest
      ? await getGearList({ limit, page: pageLoaded + 1 })
      : await getGearLike(likeGearSlug, { limit, page: pageLoaded + 1 });

    setHits(prevState => [...prevState, ...response.hits]);
    setPageLoaded(prevState => prevState + 1);
  }

  const toggleFavorite = useCallback(
    (slug: string, isFavorite: boolean) => handleFavorite(slug, isFavorite, setSnackbarMessage),
    [], // eslint-disable-line react-hooks/exhaustive-deps
  );

  const onShare = useCallback((slug: string) => handleShare(slug, setSnackbarMessage), []); // eslint-disable-line react-hooks/exhaustive-deps

  const onComment = useCallback(goToComment, []);

  return (
    <div className={styles.likeGear}>
      <h2 className={styles.likeGearTitle}>{title}</h2>
      <div className={styles.gearsGreed}>
        {hits.map((item: ProfileGear) => (
          <GearCard
            key={item.id}
            {...item}
            toggleFavorite={isFullyAuth ? toggleFavorite : redirectToAuth}
            onShare={isFullyAuth ? onShare : redirectToAuth}
            onComment={isFullyAuth ? onComment : redirectToAuth}
            shape={'mid'}
          />
        ))}
      </div>

      <div className={styles.likeGearLoadMore}>
        {!allPagesLoaded && (
          <div>
            <Button
              caption="Show More"
              action={loadMore}
              buttonType="blue"
            />
          </div>
        )}
      </div>
    </div>
  );
};
